import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 로그인 처리를 위한 키를 가져온다.
   * @author Ju
   * @return {[type]} [description]
   */
  getLoginKey() {
    return axios.get(`${baseUrl}/login/key.do`);
  },
  /**
   * 암호화된 ID와 PW로 로그인을 시도한다.
   * @author Ju
   * @param  {[type]} id 암호화딘 계정 아이디
   * @param  {[type]} pw 암호회된 계정 비밀번호
   * @return {[type]}    [description]
   */
  actionLogin(id, pw) {
    return axios.post(`${baseUrl}/login/sign-in.do`, {
      managerId: id,
      password: pw,
    });
  },

  /**
   * 로그인 상태인지를 확인한다.
   * @author Cho
   * @return {[type]} spring security에 저장된 사용자 정보
   */
  checkLogin() {
    return axios.get(`${baseUrl}/login/check.do`);
  },
  /**
   * 인증 번호를 발급한다.
   * @author Cho
   * @return {[type]}    [description]
   */
  generateAuthKey() {
    return axios.get(`${baseUrl}/login/generate-auth-key.do`);
  },
  /**
   * 입력한 인증 번호와 발급된 인증 번호가 일치하는지 확인한다.
   * @author Cho
   * @param  {[type]} key 인증 번호
   * @return {[type]}         [description]
   */
  checkAuthKey(key) {
    return axios.post(`${baseUrl}/login/check-auth-key.do`, {
      authKey: key,
    });
  },
  /**
   * 로그아웃 한다
   * @author Cho
   * @return {[type]} [description]
   */
  actionLogout() {
    return axios.get(`${baseUrl}/login/sign-out.do`);
  },
  /**
   * 비밀번호 질문 목록을 조회한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getPasswordQuestions() {
    return axios.get(`${baseUrl}/login/get-password-questions.do`);
  },
  /**
   * 비밀번호를 초기화하고 초기화된 비밀번호를 메일로 전송한다.
   * @author Ju
   * @param  {[type]} managerId            [description]
   * @param  {[type]} passwordLostQuestion [description]
   * @param  {[type]} passwordLostAnswer   [description]
   */
  resetPassword(managerId, passwordLostQuestion, passwordLostAnswer) {
    return axios.post(`${baseUrl}/login/reset-password.do`, {
      managerId,
      passwordLostQuestion,
      passwordLostAnswer,
    });
  },
  /**
  * 로그인 된 계정에 대해서 패스워드 정책 정보(권고/강제)를 가져온다.
  * (화면 프레임이 재구성될 때 passwordPolicyData가 없어 비밀번호 권고/강제 팝업이 필요함에도 띄우지 못함)
  *
   * @author Song
   */
  getMgrPasswordPolicyData() {
    return axios.get(`${baseUrl}/login/get-mgr-password-policy-data.do`);
  },
  /**
   * 고객사 아이디를 조회
   * @author najong
   */
  getCustomerId() {
    return axios.get(`${baseUrl}/login/get-customer-id.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/login.js